import axios from 'axios';
import c from '../helpers/constants';
import { getApiKey } from '../helpers/functions';

export function getAccountSummary(customerid: string) {
  return (
    axios({
      url: `${c.API_ENDPOINTS.ACCOUNT_SUMMARY}?customerid=${encodeURIComponent(customerid)}&stat_type=summary`,
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'x-api-key': getApiKey()
      },
    })
      .then((response: any) => {
        return response;
      })
      .catch((error: any) => {
        return error.response?.data;
      })
  );
}  